import { render, staticRenderFns } from "./fundOwnerSelect.vue?vue&type=template&id=558835ed"
import script from "./fundOwnerSelect.vue?vue&type=script&lang=js"
export * from "./fundOwnerSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports